import { optionSchema } from "@/common/schemas/option.schema";
import z from "zod";

export const diagnosticObjectiveActivitySchema = z.object({
  display_name: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
  description: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
  unit_price: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
  quantity: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
  warranty_in_days: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
  technical_professional: z.array(optionSchema, { message: 'Selecione pelo menos um profissional' })
    .min(1, { message: 'Selecione pelo menos um profissional' }),
  images_attachments_attributes: z.array(
    z.object({
      id: z.string(),
      file: z.custom<File | string>(),
    }),
  ),
  unit_for_quantity: optionSchema,
});

export type DiagnosticObjectiveActivityValidationSchema = z.infer<typeof diagnosticObjectiveActivitySchema>;
